import React from "react";
import { Modal, VbButton } from "@/components/vb";
import { useAuth } from "@/context/AuthContext";
import { projectsInstance } from "@/services/ProjectsService";
import { useReportsStore } from "@/store/store";
import { useWorkspace } from "@/context/WorkspaceContext";

type EligibleReportDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  companyName: string;
  reportId: number;
};

export const EligibleReportDialog: React.FC<EligibleReportDialogProps> = ({
  open,
  onOpenChange,
  companyName,
  reportId,
}) => {
  const { token } = useAuth();
  const setGenerateDialogRequest = useReportsStore((s) => s.setGenerateDialogRequest);
  const { activeWorkspace } = useWorkspace();

  const handleConfirm = async () => {
    const res = await projectsInstance.upgradeReport(reportId, token, activeWorkspace?.id);
    const upgradedId = res?.report?.report_id;
    onOpenChange(false);
    // Stay put; the progress dialog is shell-mounted and navigates to the
    // upgraded report itself once it completes. The old bounce through `/`
    // only existed so Home could mount the polling hook (AITS-540).
    setGenerateDialogRequest(upgradedId as number);
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      widthClassName="max-w-[520px]"
      bare
      title="You are now eligible for a new report for this month."
      description={
        <>
          Do you want to generate a full report for{" "}
          <span className="whitespace-nowrap font-semibold text-vb-text">{companyName}</span>?
        </>
      }
      footer={
        <>
          <VbButton variant="secondary" onClick={() => onOpenChange(false)}>
            No
          </VbButton>
          <VbButton onClick={handleConfirm}>Yes, generate full report</VbButton>
        </>
      }
    />
  );
};

export default EligibleReportDialog;
